import { LitElement, html } from 'lit';
import tippy, { hideAll } from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light-border.css';

const CHILD = R.path(['childNodes', 0]);

const TIPPY_OPTION_BASE = {
    theme: 'light-border',
    allowHTML: true,
    arrow: true,
    animation: 'fade',
    trigger: 'mouseenter', // mouseenter, click
    interactive: false,
    appendTo: R.always(document.body),
    duration: [200, 0],
    delay: [100, 0],
    onShow: hideAll,
};

class Tooltip extends LitElement {
    constructor() {
        super();

        this.instance = null;
    }

    static get properties() {
        return {
            content: {
                type: String,
            },
            maxWidth: {
                type: Number,
            },
        };
    }

    updated(props) {
        if (props.has('content')) {
            this.instance?.setContent(this.content);
        }
    }

    createInstance() {
        if (this.instance) {
            return;
        }

        const child = CHILD(this);

        if (child) {
            this.instance = tippy(child, {
                ...TIPPY_OPTION_BASE,
                content: this.content,
                maxWidth: this.maxWidth || 200,
            });
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.instance?.destroy();
    }

    render() {
        return html`<slot @mouseenter=${this.createInstance}></slot> `;
    }
}

customElements.define('ui-tooltip', Tooltip);
